import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoggedInGuard  {
  constructor(
    private router: Router,
    private auth: AuthService,
    private route: ActivatedRoute
  ) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      return this.auth.getAuthState().pipe(
        mergeMap((user) => {
          // ログイン済みの場合はログインページに飛ばさない
          return user ? this.router.navigate(['/home/history'], {relativeTo: this.route }) : of(true);
        })
      );
  }
}
